<template>
	<div class="page-login">
		<div class="container">
			<!-- Login Logo -->
			<div class="login-logo text-center">
				<picture>
					<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				</picture>
			</div>
			<!-- Login Box -->
			<div class="login-box card">
				<div class="login-box-content">
					<!-- Login Fields -->
					<template v-if="!isShowResetPassword">
						<div class="login-error callout callout--danger hidden" v-if="loginError">
							<div class="callout__content">{{ loginError }}</div>
						</div>
						<form @submit.prevent="login({ email, password })">
							<div class="mb-3">
								<h2 class="font-weight-normal">{{ $t('Log In') }}</h2>
							</div>
							<!-- Email -->
							<div class="form-group mb-2">
								<label>{{ $t('Email') }}</label>
								<input type="email" name="email" class="form-control" v-model="email" required>
								<span v-if="!isValidEmailAddress && email !== ''" class="text-danger text-small">{{$t('Invalid Email Address')}}</span>
							</div>
							<!-- Password -->
							<div class="form-group mb-3">
								<label>{{ $t('Password') }}</label>
								<input-password v-model="password" />
							</div>
							<!-- Submit -->
							<button
								:disabled="!isValidEmailAddress"
								type="submit"
								class="btn btn-submit-login btn-primary mt-3 mb-2"
								:class="{ 'is-loading': isChecking || isLoggingIn }">
								{{ $t('Log In') }}
							</button>
							<div class="login-extra d-flex justify-content-between mt-4 mb-2">
							<div>
								<label class="custom-control custom-checkbox mb-4">
								<input type="checkbox" class="custom-control-input" v-model="isRemember">
								<span class="custom-control-label pt-1">{{ $t('Remember me') }}</span>
							</label>
							</div>
							<div>
								<router-link class="pt-3 link-white-nodecor" to="/magic-link">{{ $t('Forgot Password') }}</router-link></div>
							</div>
						</form>
					</template>
					<div class="text-center">
						<label class="mr-2">{{$t('Don\'t have an account?')}}</label>
						<router-link class="login-action mr-2" to="/register">{{ $t('Create Account') }}</router-link>
						<div><router-link class="login-action" to="/confirmation-email">{{ $t('Resend confirmation email') }}</router-link></div>
					</div>
					<!-- Reset Password -->
					<template v-if="isShowResetPassword">
						<div class="login-error callout callout--danger" v-if="resetPasswordError">
							<div class="callout__content">{{ resetPasswordError }}</div>
						</div>
						<div class="login-error callout callout--success" v-if="resetPasswordSuccess">
							<div class="callout__title">Please Check Your Email</div>
							<div class="callout__content">If your email is registered in Grafias, you will receive a link to reset your password in your email inbox</div>
						</div>
						<form @submit.prevent="resetPassword({ email, password })">
							<h3 class="m-0 text-left">{{ $t('Reset Password') }}</h3>
							<div class="form-group">
								<md-field>
									<md-icon>email</md-icon>
									<label>{{ $t('Email') }}</label>
									<md-input name="email" v-model="email"></md-input>
								</md-field>
							</div>
							<div class="d-flex justify-content-between align-items-center">
								<a class="login-action" @click="showLogin">{{ $t('Login') }}</a>
								<button type="submit" class="btn btn-submit btn-primary" :class="{ 'is-loading': isResettingPassword }" @click="resetPassword">{{ $t('Reset') }}</button>
							</div>
						</form>
					</template>
				</div>
			</div>
			<div class="d-flex align-items-center justify-content-between login-box-action">
				<!-- <div class="col-50">
					<div class="flex-center">
						<div class="w-100">{{ $t('Language') }}:</div>
						<md-menu md-size="medium" md-direction="bottom-end" md-align-trigger>
							<md-button class="md-button-plain" md-menu-trigger>
								<span class="va-m">{{ languageLabel[lang] }}</span>
								<i class="material-icons va-m">arrow_drop_down</i>
							</md-button>
							<md-menu-content>
								<md-menu-item @click="setLanguage('en')">English</md-menu-item>
								<md-menu-item @click="setLanguage('no')">Norsk</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				</div> -->
			<!-- <div><router-link class="login-action mr-2" to="/magic-link">{{ $t('Email me magic link to login') }}</router-link></div> -->
			</div>
		</div>
		<div class="modals">
			<!-- Login Error -->
			<modal class="login-error-modal" size="small" v-if="error" @close="error = false">
				<div slot="header">{{$t('Login Error')}}</div>
				<div slot="body" class="text-left">
					<div v-if="errorMessage === ''">{{ $t('Wrong Email or Password') }}</div>
					<div v-else>{{ errorMessage }}</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-secondary" @click="error = false">OK</button>
				</div>
			</modal>
		</div>
		<modal-check-login :isShowCheckLogin="isShowCheckLogin"
		@checkLogin="checkLogin"
		@close="closeCheckLogin"
		></modal-check-login>
		<footer
			class="footer footer-main">
			<div class="d-flex justify-content-between">
				<div>
					<div class="footer-brand text-grey"> <span>{{ $t('Ver.') }} {{ appVersion }}</span></div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import InputPassword from '@/components/InputPassword.vue';
import { getAxiosErrorMessage, isValidEmail } from '@/lib/helper';
import authApi from '@/api/auth';
import ModalCheckLogin from '@/components/ModalCheckLogin.vue';
import {
	appVersion,
} from '@/lib/statics';

export default {
	name: 'Login',
	components: {
		Modal,
		InputPassword,
		ModalCheckLogin,
	},
	data() {
		return {
			email: '',
			password: '',
			typePassword: 'password',
			isShowResetPassword: false,
			isResettingPassword: false,
			resetPasswordError: false,
			resetPasswordSuccess: false,
			error: false,
			errorMessage: '',
			languageLabel: {
				en: 'English',
				no: 'Norsk',
			},
			isRemember: false,
			isShowCheckLogin: false,
			credentials: null,
			isChecking: false,
		};
	},
	methods: {
		...mapActions({
			setLocale: 'setLocale',
		}),
		checkLogin() {
			this.$store.dispatch('login', this.credentials);
		},
		closeCheckLogin() {
			this.isShowCheckLogin = false;
		},
		login() {
			this.isChecking = true;
			this.credentials = {
				email: this.email,
				password: this.password,
				device: 'test',
				is_mobile: isMobile,
			};
			const callback = (response) => {
				const user = response.data;
				if (user && user.is_another_login && !user.is_spectator) {
					this.isShowCheckLogin = true;
				} else {
					this.$store.dispatch('login', this.credentials);
				}
				this.isChecking = false;
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Reset Password',
					text: message,
				});
				this.isChecking = false;
			};
			const params = {
				email: this.email,
				password: this.password,
				lang: 'en',
				device: 'test',
				is_mobile: isMobile,
			};
			authApi.checkLogin(params, callback, errCallback);
		},
		resetPassword() {
			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Reset Password',
					text: 'Please check your email for password reset insctructions',
				});
				this.resetPasswordSuccess = true;
				this.isResettingPassword = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Reset Password',
					text: message,
				});
				this.isResettingPassword = false;
			};
			authApi.resetPassword(this.email, callback, errorCallback);
			this.isResettingPassword = true;
		},
		showResetPassword(event) {
			event.preventDefault();
			this.isShowResetPassword = true;
		},
		showLogin() {
			this.isShowResetPassword = false;
		},
		setLanguage(lang) {
			this.$router.push({ query: { lang } }).catch(() => {});
		},
		showPassword() {
			if (this.typePassword === 'password') {
				this.typePassword = 'text';
			} else {
				this.typePassword = 'password';
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			locale: 'locale',
			isLoggingIn: 'isLoggingIn',
			loginError: 'loginError',
		}),
		action() {
			const { action } = this.$route.query;
			return action;
		},
		lang() {
			const lang = this.$route.query.lang || this.locale;
			return lang;
		},
		appVersion() {
			return appVersion;
		},
		isValidEmailAddress() {
			return isValidEmail(this.email);
		},
	},
	watch: {
		loginError(loginError) {
			if (loginError) {
				this.error = true;
				this.errorMessage = loginError;
			}
		},
	},
	created() {
		document.body.classList.add('login');
		if (this.action && this.action === 'forgot_password') {
			this.isShowResetPassword = true;
		}
	},
	destroyed() {
		document.body.classList.remove('login');
	},
};
</script>
